import React, { Fragment, useMemo } from "react";
import { withTranslation } from "react-i18next";
import { Col, Row } from "reactstrap";
import { get } from "lodash";
import PropTypes from "prop-types";

import { getOptionLabel } from "common/enums";
import Collapse from "./Collapse";

const BuildingAuthorityView = ({
  buildingAuthorities,
  isExpandable = true,
  t,
}) => {
  const fields = useMemo(
    () => [
      {
        name: "Authority Role",
        key: "buildingAuthorityRoleId",
        renderField: (value) =>
          getOptionLabel("buildingAuthorityRoleEnum", value) ?? "-",
      },
      {
        name: "Name",
        key: "name",
        isRequired: true,
      },
      {
        name: "Mobile Number",
        key: "mobileNumber",
        isRequired: true,
      },
      {
        name: "Email",
        key: "email",
        isRequired: true,
      },
    ],
    []
  );

  return (
    <>
      <Collapse title="Building Authority Details" isExpandable={isExpandable}>
        {buildingAuthorities.map((authority, index) => (
          <Fragment key={index}>
            <Row className="d-flex  mb-2">
              <label className="fw-semibold">
                {t("Building Authority") + " : " + (index + 1)}
              </label>
              {fields.map(({ name, key, isRequired, renderField }) => {
                const value = get(authority, key, "");
                return (
                  <Col key={key} lg={6} className="mb-1">
                    <Row>
                      <Col md={5}>{t(name)}:</Col>
                      <Col
                        md={7}
                        className="fw-semibold"
                        style={{ wordBreak: "break-word" }}
                      >
                        {renderField
                          ? renderField(value)
                          : get(authority, key, null) ??
                            (isRequired ? "-" : "N/A")}
                      </Col>
                    </Row>
                  </Col>
                );
              })}
            </Row>
          </Fragment>
        ))}
      </Collapse>
    </>
  );
};

BuildingAuthorityView.propTypes = {
  buildingAuthorities: PropTypes.object,
  isExpandable: PropTypes.bool,
  t: PropTypes.func,
};

export default withTranslation()(BuildingAuthorityView);
